export interface ImportPcgEntriesParametersJson {
  update_label: string;
  header: string;
  pcg_entries_label: string;
}

export class ImportPcgEntriesParameters {
  constructor(
    public updateLabel?: boolean,
    public header?: boolean,
    public pcgEntriesLabel?: string,
    public file?: File
  ) {}

  static toJson(importPcgEntriesParameters: ImportPcgEntriesParameters): ImportPcgEntriesParametersJson {
    return {
      update_label: importPcgEntriesParameters.updateLabel.toString(),
      header: importPcgEntriesParameters.header.toString(),
      pcg_entries_label: importPcgEntriesParameters.pcgEntriesLabel
    };
  }
}
